module.exports = __webpack_public_path__ + "static/media/85.1561cbe0.png";